 <app-type-voie  [uid]="getUid()" [parentForm]="parentForm" 
 [voie]="lieuExecutionLivraison?.voie"></app-type-voie>

<app-form-input 
[parentForm]="parentForm" 
[value]="lieuExecutionLivraison?.cp" 
[label]="step2.getcp"
[type]="'text'"
[rule]="'pattern_3'"
[name]="getUid()+'_SepAtt_cp'">
</app-form-input>

<app-form-input 
[parentForm]="parentForm" 
[value]="lieuExecutionLivraison?.ville" 
[label]="step2.getville"
[type]="'text'"
[rule]="'minSize_1|maxSize_100'"
[name]="getUid()+'_SepAtt_ville'">
</app-form-input>
